module.exports = __webpack_public_path__ + "static/workbench-skeleton-9d869b8f63c8ee00acb865596b666499.jpg";